import { FC } from 'react';
import type { CustomChartTextSummaryPayload } from '@/entities/dashboards';
import { RichTextContent } from '@/shared/ui';
import { ChartCardShell } from '../ChartCardShell';

type Props = {
  title: string;
  payload: CustomChartTextSummaryPayload;
};

/**
 * Текстовая сводка: связный текст, составленный по отобранным правилом агрегатам.
 *
 * Текст показывается ровно так, как набран: перечень величин остаётся перечнем строк, а знаки
 * внутри подставленных значений остаются знаками.
 */
export const TextSummaryChartView: FC<Props> = ({ title, payload }) => (
  <ChartCardShell title={title}>
    <RichTextContent html={payload.markdown} className="w-full" />
  </ChartCardShell>
);
